import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import { useChSetCallerConsentMutation as useChSetCallerConsentMutationType } from "@/modules/patients/services/ch/__generated__/useChSetCallerConsentMutation.graphql"

export const mutation = graphql`
  mutation useChSetCallerConsentMutation($input: Ch_setCallRecordingConsentInput!) {
    ch_setCallRecordingConsent(input: $input) {
      boolean
      errors {
        ... on Error {
          __typename
          message
        }
      }
    }
  }
`

export const useChSetCallerConsentMutation = () => {
  return useMutation<useChSetCallerConsentMutationType>(mutation)
}
